/**
 * Hospital Representantes Service
 *
 * Epic 28: Upload de representantes por hospital
 * Endpoints: /api/hospitais/{id}/representantes/import-excel
 */
import apiClient from './apiClient';

export interface ImportRepresentantesResult {
  success: boolean;
  hospital_id: number;
  hospital_codigo: string;
  hospital_nome: string;
  created: number;
  updated: number;
  vinculos_criados: number;
  errors: string[];
  warnings: string[];
  total_linhas_processadas: number;
}

class HospitalRepresentantesService {
  /**
   * Baixa template Excel para importação de representantes
   * Template vem pré-preenchido com código e nome do hospital
   */
  async downloadTemplate(hospitalId: number): Promise<Blob> {
    const response = await apiClient.get(
      `/hospitais/${hospitalId}/representantes/template-excel`,
      { responseType: 'blob' }
    );

    return response.data;
  }

  /**
   * Importa representantes via Excel para um hospital específico
   *
   * Validações Epic 28:
   * - código_hospital no Excel deve corresponder ao hospital_id
   * - Cria representantes com cliente=null por padrão
   * - Cria vínculo HospitalRepresentante automaticamente
   */
  async importExcel(hospitalId: number, file: File): Promise<ImportRepresentantesResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ImportRepresentantesResult>(
      `/hospitais/${hospitalId}/representantes/import-excel`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  }
}

export default new HospitalRepresentantesService();
